'use strict'

Object.defineProperty(exports, '__esModule', {
  value: true
})

var _templateObject = _taggedTemplateLiteral(
  [
    '\n  border-radius: ',
    ';\n  display: inline-block;\n  font-weight: normal;\n  letter-spacing: 0.04em;\n  line-height: 1.25;\n  text-transform: uppercase;\n'
  ],
  [
    '\n  border-radius: ',
    ';\n  display: inline-block;\n  font-weight: normal;\n  letter-spacing: 0.04em;\n  line-height: 1.25;\n  text-transform: uppercase;\n'
  ]
)

var _Text = require('./Text')

var _Text2 = _interopRequireDefault(_Text)

var _theme = require('./theme')

var _theme2 = _interopRequireDefault(_theme)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(
    Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })
  )
}

var Badge = _Text2.default.span.extend(_templateObject, function(props) {
  return props.theme.radius
})

Badge.displayName = 'Badge'

Badge.defaultProps = {
  theme: _theme2.default,
  px: 2,
  py: 1,
  bg: 'primary',
  color: 'white',
  f: 1
}

exports.default = Badge



//////////////////
// WEBPACK FOOTER
// ./~/@hackclub/design-system/dist/Badge.js
// module id = 67
// module chunks = 35783957827783 114276838955818 214865505688126